// extracted by mini-css-extract-plugin
export default {"root":"styles_root__FGbdN","disabled":"styles_disabled__mxQ8Q"};